/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js"
import { AbilityModel } from '../../../models/AbilityModel'
import { GET_SUPPLIER_OPTIONS } from '../../../constants/endpoints'
import { formatPrice, revertPriceNumner } from '../../../selectors'
import { ABILITIES_PAYMENT_METHOD, FORCE_BANKING_METHOD, PAYMENT_VOUCHER_TYPE_OPTIONS } from '../../../constants/common'
import { AsyncSelect2Supplier } from '../../../../_metronic/partials/select/AsyncSelect2Supplier'
import { NumericFormat } from 'react-number-format'
import moment from 'moment'
import { GetStoreIfo } from '../../../hooks/PermissionChecker';
import { removeTrailingZeros } from '../../../modules/common/helper';

type Props = {
    show: boolean
    mode: string
    data?: AbilityModel
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
    setInvoiceFile: (file: File) => void
}

const addSchema = Yup.object().shape({
    name: Yup.string().required('Vui lòng chọn nhập tên'),
    //supplier_id: Yup.string().nullable().required('Vui lòng chọn nhà cung cấp'),
    value: Yup.string().required('Vui lòng nhập giá trị')
})

const PaymentVoucher: React.FC<Props> = ({ show, mode, data, onClose, onSubmit, setInvoiceFile }) => {
    const storeInfo = GetStoreIfo();
    const supplier = data?.supplier
    let supplierDebt = removeTrailingZeros(supplier?.opening_debt ?? 0) + removeTrailingZeros(supplier?.receipt_detail_sum_sub_total ?? 0) - removeTrailingZeros(supplier?.ability_sum_value ?? 0);
    if (supplier?.consignment_supplier_id && supplier?.consignment_receipt_total && supplier?.consignment_receipt_total > 0) {
        supplierDebt+= removeTrailingZeros(supplier?.consignment_receipt_total);
    }
    supplierDebt -= (supplier?.consignment_refund_total ?? 0);
    const dataExpenseGroup = data?.id ? (
        data?.expense_group !== null && data?.expense_group !== '' ? data?.expense_group : data?.purpose
    ) : 'debt'

    let initValues: any = {
        id: data?.id ?? null,
        expense_group: dataExpenseGroup === 'expenses' ? 'debt' : dataExpenseGroup,
        purpose: data?.purpose ?? null,
        supplier: {label: supplier?.name, value: supplier?.id},
        supplier_id: supplier?.id ?? null,
        name: data?.id ? data.name : (supplier?.name ?? ''),
        address: supplier?.address ?? '',
        dept: supplierDebt,
        payment_method: data?.payment_method ?? 'banking',
        date: data?.date ? moment(data.date, 'DD-MM-YYYY').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        value: data?.value ?? 0,
        note: data?.note ?? '',
        doc_label: data?.doc_label ?? ''
    };
    let defaultBank = storeInfo?.banks?.find((b) => b.is_default == 1) ?? undefined;
    if (initValues.payment_method === 'banking') {
        initValues = {
            ...initValues,
            bank_id: data?.bank_id ?? (defaultBank?.id ?? null)
        }
    }
    const uploadInvoice = async (e: any) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }
        setInvoiceFile(file);
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>{mode === 'edit' ? 'Cập nhật phiếu chi' : 'Tạo phiếu chi'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
                <Formik enableReinitialize validationSchema={addSchema} initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Loại chi phí</label>
                                    <Field
                                            as='select'
                                            name='expense_group'
                                            className='form-select'
                                            disabled={data?.expense_group === 'debt' || dataExpenseGroup === 'expenses'}
                                    >
                                        {PAYMENT_VOUCHER_TYPE_OPTIONS.filter((opt) => opt.value !== 'sales_refund').map((opt) => {
                                            return <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        })}
                                    </Field>
                                </div>
                                {values?.expense_group === 'payroll' && (
                                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                        <Field
                                            as='select'
                                            name='purpose'
                                            className='form-select'
                                        >
                                            <option value="salary">Lương</option>
                                            <option value="s_insurance">BHXH</option>
                                            <option value="h_insurance">BHYT</option>
                                            <option value="u_insurance">BHTN</option>
                                        </Field>
                                    </div>
                                )}
                                
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Tên người chi</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder=''
                                        autoComplete='nope'
                                        name='name'
                                        required
                                    />
                                    <ErrorMessage className='text-danger' component='span' name='name' />
                                </div>
                                {(values?.expense_group === 'debt') && (
                                    <>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="required form-label">Nhà cung cấp</label>
                                            <AsyncSelect2Supplier
                                                name="supplier"
                                                placeholder=""
                                                isGray
                                                sourceUrl={GET_SUPPLIER_OPTIONS}
                                                defaultOptions
                                                defaultValue={initValues?.supplier ?? null}
                                                default
                                                required
                                                addQueryString={'is_not_consigment=1&with_debt=1'}
                                                onChange={(selectedOption: any) => {
                                                    handleChange({target: {name: 'supplier', value: selectedOption}});
                                                    handleChange({target: {name: 'supplier_id', value: selectedOption.value}});
                                                    handleChange({target: {name: 'dept', value: selectedOption.dept}});
                                                    handleChange({target: {name: 'address', value: selectedOption.address}});
                                                }}
                                            />
                                            <ErrorMessage className='text-danger' component='span' name='supplier_id' />
                                        </div>
                                        <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                            <label className="form-label">Địa chỉ</label>
                                            <Field
                                                type='text'
                                                className='form-control'
                                                placeholder=''
                                                autoComplete='nope'
                                                name='address'
                                            />
                                            <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='address' /></div>
                                        </div>
                                        {!data?.id && (
                                            <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                                <label className="form-label">Công nợ cũ</label>
                                                <Field
                                                    type='text'
                                                    className='form-control'
                                                    placeholder=''
                                                    autoComplete='nope'
                                                    name='dept'
                                                    value={formatPrice(values.dept)}
                                                    readOnly
                                                />
                                                <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='address' /></div>
                                            </div>
                                        )}
                                        
                                    </>
                                )}
                                
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="required form-label">Số tiền chi</label>
                                    <NumericFormat
                                        thousandSeparator=","
                                        name='value'
                                        required
                                        value={removeTrailingZeros(values?.value ?? 0)}
                                        className='form-control form-control-sm'
                                        onBlur={(e) => {
                                            handleChange({target: {name: 'value', value: revertPriceNumner(e.target.value)}});
                                            handleChange({target: {name: 'new_dept', value: values.dept - revertPriceNumner(e.target.value)}});
                                        }}
                                    />
                                    
                                    <ErrorMessage className='text-danger' component='span' name='value' />
                                </div>
                                {!data?.id && values?.expense_group === 'debt' && (
                                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                        <label className="form-label">Công nợ còn lại</label>
                                        <Field
                                            type='text'
                                            className='form-control'
                                            placeholder=''
                                            autoComplete='nope'
                                            value={formatPrice(values.new_dept)}
                                            name='new_dept'
                                        />
                                        <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='value' /></div>
                                    </div>
                                )}
                                {!FORCE_BANKING_METHOD.includes(values?.expense_group) && (
                                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                        <label className="form-label">Phương thức thanh toán</label>
                                        <Field
                                            as='select'
                                            name='payment_method'
                                            className='form-select'
                                        >
                                            <option value=""></option>
                                            {ABILITIES_PAYMENT_METHOD.map((method: any) => (
                                                <option key={method.id} value={method.id}>{method.label}</option>
                                            ))}
                                        </Field>
                                    </div>
                                )}
                                {values?.payment_method === 'banking' && (
                                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                        <label className="form-label">Ngân hàng</label>
                                        <Field
                                            as='select'
                                            name='bank_id'
                                            className='form-select'
                                        >
                                            <option value=""></option>
                                            {storeInfo?.banks?.map((bank: any) => (
                                                <option key={bank.id} value={bank.id}>{bank.bank_name} - {bank.bank_account_number}</option>
                                            ))}
                                        </Field>
                                    </div>
                                )}
                                
                                {/* {values?.expense_group !== 'debt' && ( */}
                                    <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                        <label className="form-label">Phân bổ</label>
                                        <Flatpickr
                                            onChange={(date) => {
                                                handleChange({target: {name: 'date', value: moment(date[0]).format('YYYY-MM-DD')}});
                                            }}
                                            value={moment(values?.date).format('DD-MM-YYYY')}
                                            options={{
                                                mode: "single",
                                                dateFormat: "d-m-Y",
                                                locale: Vietnamese,
                                                shorthandCurrentMonth: true,
                                                defaultDate: moment().format('DD-MM-YYYY')
                                            }}
                                            className='form-control'
                                            placeholder=''
                                        />
                                    </div>
                                {/* )} */}
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className='form-label fw-bold '>Mã HD</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder=''
                                        autoComplete='nope'
                                        name='doc_label'
                                    />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className='form-label fw-bold '>File</label>
                                    <input  onChange={uploadInvoice} type="file" accept="image/png, image/gif, image/jpeg, application/pdf" />
                                </div>
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Ghi chú</label>
                                    <Field
                                        as="textarea"
                                        className="form-control"
                                        value={values.note ?? ""}
                                        id="note"
                                        name="note"
                                        rows={3}
                                    />
                                    <div className="fv-plugins-message-container invalid-feedback"><ErrorMessage name='note' /></div>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Hủy</button>
                                <button className="btn btn-bg-success" type="submit">{data?.id ? 'Cập nhật' : 'Thêm'}</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentVoucher
